import { notification } from './notification';

export const eventFactory = {
  notification,
};
